<template>
    <Layout data-step="choice">
        <HomeResultsList />
    </Layout>
</template>

<script>
import Layout from '@/views/home/layout.vue';
import HomeResultsList from '@/views/home/components/HomeResultsList.vue';

export default {
    components: { Layout, HomeResultsList },
}
</script>
